export default __webpack_public_path__ + "static/925-dc32268e32626e598394a7369cb1e775.gif";